import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageGuestsComponent } from './manage-guests/manage-guests.component';
import { EditGuestComponent } from './edit-guest/edit-guest.component';
import { SharedModule } from 'app/shared';
import { CreateGuestComponent } from './create-guest/create-guest.component';
import { IdentityMatchDialogComponent } from './create-guest/identity-match-dialog/identity-match-dialog.component';
import { GuestFormComponent } from './shared/guest-form/guest-form.component';
import { RoleFormComponent } from './shared/role-form/role-form.component';
import { UnauthorizedPageComponent } from '../shared/components/unauthorized-page/unauthorized-page.component';
import { GuestSearchComponent } from '../sponsor/shared/guest-search/guest-search.component';
import { MatCardModule } from '@angular/material/card';
import { RoleHistoryComponent } from './shared/role-history/role-history.component';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmation-dialog/confirmation-dialog.component';


@NgModule({
    declarations: [
        ManageGuestsComponent,
        EditGuestComponent,
        CreateGuestComponent,
        IdentityMatchDialogComponent,
        GuestFormComponent,
        RoleFormComponent,
        GuestSearchComponent,
        RoleHistoryComponent,
    ],
    imports: [
        SharedModule,
        CommonModule,
        MatCardModule
    ],
    exports: []
})
export class SponsorModule { }
